import script from "./CardScreen.vue?vue&type=script&setup=true&lang=ts"
export * from "./CardScreen.vue?vue&type=script&setup=true&lang=ts"

import "./CardScreen.vue?vue&type=style&index=0&id=3f721376&scoped=true&lang=scss"

import exportComponent from "/app/fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f721376"]])

export default __exports__